import { render } from "./MessageErrors.vue?vue&type=template&id=20d06f5a"
import script from "./MessageErrors.vue?vue&type=script&lang=js"
export * from "./MessageErrors.vue?vue&type=script&lang=js"
script.render = render

export default script